export type NoneAll = "none" | "all";
export type NoneSomeAll = NoneAll | "some";

export function computeNoneSomeAll<E>(
  items: E[],
  isSelected: (e: E) => boolean,
): NoneSomeAll {
  const nbSelected = items.filter(isSelected).length;
  return (
    nbSelected === 0 ? "none"
    : nbSelected === items.length ? "all"
    : "some"
  );
}

export function computeNoneSomeAllFromLengths(
  nbAvailable: number,
  nbSelected: number,
): NoneSomeAll {
  return (
    nbSelected === 0 ? "none"
    : nbSelected === nbAvailable ? "all"
    : "some"
  );
}
